import { render, staticRenderFns } from "./MyIncome.vue?vue&type=template&id=a165b8b6&scoped=true&"
import script from "./MyIncome.vue?vue&type=script&lang=js&"
export * from "./MyIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a165b8b6",
  null
  
)

export default component.exports